import { Alert, AlertDescription } from "@altimateai/lego";

interface FormAlertProps {
  error?: string | null | false;
}

const FormAlert = ({ error }: FormAlertProps) => {
  if (!error) return null;

  return (
    <Alert variant="destructive" className="al-mt-3 al-mb-3">
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
};

export default FormAlert;
